import { getParent, types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const getExistingFeesAsync = createAsync(function () {
  let isNotCompleted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return async function getExistingFees(options) {
    const resp = await api.Fees.getExistingFees(options);
    if (getParent(this).addNewProperty.completedStep === 0 || isNotCompleted) {
      getParent(this).addNewProperty.feeStructure.changesFeesTypes(resp.response);
    }
    return resp;
  };
});
const FeesStore = types.model('FeesStore', {
  getExistingFeesAsync
});
export const fees = types.optional(FeesStore, {});